/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Button, Row, Col, FormControl, Spinner, Form, Carousel, Modal } from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import { Redirect } from 'react-router-dom';

//project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { invoiceDetail, updateInvoice, secret_key, voidInvoice, transactionHistory } from 'shared/settings/apiconfig';
// import toast from 'shared/toast';
import { ToasterMessage } from 'shared/toast/toast';


//style imports
import './InvoiceEdit.scss';
import { NoData } from 'features/components/redirect/NoData';

const decimalTypes = ['shippinghandling', 'additionalamount'];
const decimalType = ['amount'];
const twodecimal = ['tax', 'buyerspremium'];

/**
 * this page is used to view invoice
 * 
 * @param props
 * 
 * @param invoiceid
 * 
 * @return html to render invoice view
 * 
**/

export class InvoiceEdit extends Component {

    invoiceData;

    constructor(props) {
        super(props);

        this.state = {
            noUpdate: true,
            updateDiscardModal: false,
            chars_left: 500,
            additionalnotes: { value: '' },
            errorpageredirect: false,
            excemptedLocation: false,
            form: {
                id: this.props.match.params.invoiceId,
                billingto: {
                    name: '',
                    addressto1: '',
                    addressto2: '',
                    cityState: '',
                    countryZipcode: '',
                    email: '',
                    phonenumber: ''
                },
                billingfrom: {
                    contactname: '',
                    address1: '',
                    address2: '',
                    cityState: '',
                    countryZipcode: '',
                    contactemail: '',
                    contactmobile: ''
                },
                buyerid: null,
                type: '',
                saleid: null,
                additionalamount: '',
                invoiceamount: '',
                trackingid: '',
                invoicemessage: '',
                createddate: '',
                timezone: '',
                items: [],
                taxExemptFlag : 1,
                total: '',
                buyerspremium: '',
                shippinghandling: '',
                tax: '',
                grossamount: '',
                amountdue: '',
                status: '',
                invoicenumber: '',
                applytaxonbp:0,
                totaltax: '',
                totaltaxamount: '',
                totalbp: '',
                totalbpamount: '',
                taxonBPamount:'',
                totalgrossamount: '',
                totalamount: '',
                buyerToken: '',
                secretKey: ''
            },
            windowWidth: window.innerWidth,
            loading: false,
            valid: true,
            invoiceStatus: { show: false, type: '', message: '' },
            voidStatus: { show: false, type: '', message: '' },
            voidModal: false,
            disableUpdate: false,
            cancelInvoice:false,
            initalInvoice:{}
        };

        this.invoiceData = {};

    }

    componentDidMount() {
        this.getSecretKey();
        window.addEventListener('resize', this.updateDimensions);
        this.getInvoiceData();
        this.getTransactionData();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
        if(this.props.location?.state?.state?.name === 'Saledashboard'){
        }else{
            window.removeEventListener('popstate', this.onBack);      
        }
    }
    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBack);
        } else {
            this.approveBack = true;
            this.navigateToBack();
        }
    }

    /* Detect window width */
    updateDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    /* Get invoice data */
    getInvoiceData = async () => {
        this.setState({ loading: true });
        let excemptedLocation = false;
        await axios.get(getSellerUrl(`${invoiceDetail}/${this.state.form.id}`), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    if (response.data.data[0]['invoicestatus'].toLowerCase() === 'unpaid') {
                        let data = response.data.data[0];
                        let items = JSON.parse(response.data.data[0].details)['items'];
                        this.invoiceData = { ...JSON.parse(response.data.data[0].details) };
                        this.invoiceData.excemptedtaxlocation.forEach(id => {
                            if (this.invoiceData.location && Number(this.invoiceData.location) === Number(id))
                                excemptedLocation = true;
                        });
                        if (this.invoiceData['additionalamount'] === undefined) {
                            this.invoiceData['additionalamount'] = '';
                        }
                        let billingfromCityDelimiter = this.invoiceData.billingfrom.city && this.invoiceData.billingfrom.state ? ', ' : '';
                        let billingfromCountryDelimiter = this.invoiceData.billingfrom.country && this.invoiceData.billingfrom.zipcode ? ', ' : '';
                        let billingtoCityDelimiter = this.invoiceData.billingto.city && this.invoiceData.billingto.state ? ', ' : '';
                        let billingtoCountryDelimiter = this.invoiceData.billingto.country && this.invoiceData.billingfrom.zipcode ? ', ' : '';
                        this.setState({
                            form: {
                                ...this.state.form,
                                billingto: {
                                    ...this.state.form.billingto,
                                    name: this.invoiceData.billingto.firstname + ' ' + this.invoiceData.billingto.lastname,
                                    addressto1: (this.invoiceData.billingto.address1 ? this.invoiceData.billingto.address1 : '') + (billingtoCityDelimiter) + (this.invoiceData.billingto.address2 ? this.invoiceData.billingto.address2 + "," : ''),
                                    cityState: (this.invoiceData.billingto.city ? this.invoiceData.billingto.city : '') + (billingtoCityDelimiter) + (this.invoiceData.billingto.state ? this.invoiceData.billingto.state : ''),
                                    countryZipcode:( this.invoiceData.billingto.country ? this.invoiceData.billingto.country : '') + (billingtoCountryDelimiter) + (this.invoiceData.billingto.zipcode ? this.invoiceData.billingto.zipcode : ''),
                                    email: this.invoiceData.billingto.email ? this.invoiceData.billingto.email : '',
                                    phonenumber: this.invoiceData.billingto.contactmobile ? this.invoiceData.billingto.contactmobile : this.invoiceData.billingto.mobile ? this.invoiceData.billingto.mobile : '',
                                },
                                billingfrom: {
                                    ...this.state.form.billingfrom,
                                    contactname: this.invoiceData.billingfrom.contactname ? this.invoiceData.billingfrom.contactname : '',
                                    address1: this.invoiceData.billingfrom.address1 ? this.invoiceData.billingfrom.address1+','+this.invoiceData.billingfrom.address2 + ',' : '',
                                    cityState: (this.invoiceData.billingfrom.city ? this.invoiceData.billingfrom.city : '') + (billingfromCityDelimiter) + (this.invoiceData.billingfrom.state ? this.invoiceData.billingfrom.state : ''),
                                    countryZipcode: (this.invoiceData.billingfrom.country ? this.invoiceData.billingfrom.country : '') + (billingfromCountryDelimiter) + (this.invoiceData.billingfrom.zipcode ? this.invoiceData.billingfrom.zipcode : ''),
                                    contactemail: this.invoiceData.billingfrom.contactemail ? this.invoiceData.billingfrom.contactemail : '',
                                    contactmobile: this.invoiceData.billingfrom.contactmobile ? this.invoiceData.billingfrom.contactmobile : ''
                                },
                                buyerid: data.buyerid,
                                type: data.type,
                                saleid: data.saleid,
                                additionalamount: String(this.invoiceData.additionalamount),
                                trackingid: this.invoiceData.trackingid ? this.invoiceData.trackingid : '',
                                shippinghandling: this.invoiceData.shippinghandling ? String(this.invoiceData.shippinghandling) : '',
                                items: items,
                                status: data.invoicestatus,
                                invoiceamount: String(data.invoiceamount),
                                invoicenumber: data.invoicenumber,
                                applytaxonbp:this.invoiceData.applytaxonbp,
                                invoicemessage: this.invoiceData.invoicemessage ? JSON.parse(this.invoiceData.invoicemessage).content.body : '',
                                createddate: data.createddate ? data.createddate : '',
                                timezone: data.timezonename ? data.timezonename : ''
                            },
                            additionalnotes: data.additionalnotes ? data.additionalnotes : '',
                            excemptedLocation: excemptedLocation,
                            loading: false
                        }, () => {
                            this.setState({
                                initalInvoice:this.state.form
                            })
                            this.calculateTotal();
                        });
                    }
                    // else {
                    //     this.props.history.push('/not-found');}
                }
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    errorpageredirect: true,
                    // invoiceStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                });
            });
    };

     /* Get transaction history data */
     getTransactionData = () => {
        const data = {
            filter: [
                { field: 'invoiceid', value: Number(this.state.form.id), op: '=', join: 'AND' }
            ]
        };
        axios.post(getSellerUrl(transactionHistory), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    if(response.data.data.length > 0){
                        this.setState({ disableUpdate: true });
                    }
                    else{
                        this.setState({ disableUpdate: false });
                    }
                }
            })
            .catch(error => {
                // toast.error(error.response.data.message);
            })
    }

    /* calculate total for invoice amount, tax, buyerspremium */
    calculateTotal = () => {
        let amountTotal = 0;
        let taxTotal = 0;
        let taxamountTotal = 0;
        let buyerspremiumTotal = 0;
        let buyerspremiumamountTotal = 0;
        let taxonbuyerspremiumTotal=0;
        let grossamountTotal = 0;
        let shippinghandling = this.state.form.shippinghandling ? this.state.form.shippinghandling : '0';
        let additionalamount = this.state.form.additionalamount ? this.state.form.additionalamount : '0';
        let Isapplytaxonbp =  this.invoiceData.applytaxonbp ? this.invoiceData.applytaxonbp : 0;

        if(this.invoiceData.excemptedtaxlocation.length > 0){
            this.invoiceData.excemptedtaxlocation.forEach(excemptedtaxlocation => {

                if(excemptedtaxlocation == this.invoiceData.location){
                    this.state.form.taxExemptFlag = 0;
                }
    
            });
        }
        

 

        this.invoiceData.items.forEach(item => {

             /* Calculation for Tax on BP Amount */
            if (this.invoiceData.applytaxonbp && this.state.form.taxExemptFlag) {
                const taxonBPamount = parseFloat(item.buyerspremiumamount * item.tax) / 100;
                item.taxonBPamount = taxonBPamount;
            }
            else {
                item.taxonBPamount = 0;
            }

            amountTotal = amountTotal + item.amount;
            taxTotal = taxTotal + item.tax;
            taxamountTotal = taxamountTotal + item.taxamount;
            taxonbuyerspremiumTotal = Isapplytaxonbp ? (taxonbuyerspremiumTotal + item.taxonBPamount) : 0;            
            buyerspremiumTotal = buyerspremiumTotal + item.buyerspremium;
            buyerspremiumamountTotal = buyerspremiumamountTotal + item.buyerspremiumamount;
            grossamountTotal = grossamountTotal + item.grossamount;
        });

        this.setState({
            form: {
                ...this.state.form,
                totalamount: amountTotal ? String(amountTotal) : '0',
                totaltax: taxTotal ? String(taxTotal) : '0',
                totaltaxamount: taxamountTotal ? String(taxamountTotal) : '0',
                totalbp: buyerspremiumTotal ? String(buyerspremiumTotal) : '0',
                totalbpamount: buyerspremiumamountTotal ? String(buyerspremiumamountTotal) : '0',
                totaltaxonbpamount: Isapplytaxonbp ? (taxonbuyerspremiumTotal ? String(taxonbuyerspremiumTotal): '0') : '0',
                totalgrossamount: grossamountTotal ? String(grossamountTotal) : '0',
                invoiceamount: parseFloat(grossamountTotal) + parseFloat(shippinghandling) + parseFloat(additionalamount)
            }
        }, () => {
            this.invoiceData['invoiceamount'] = this.state.form.invoiceamount;
            this.invoiceData['totalamount'] = this.state.form.invoiceamount;
        });
    };

    // update value of input
    onInputChange = (event, index) => {
        let value = event.target.value !== '' ? parseFloat(event.target.value) : 0;
        if (((event.nativeEvent.data === '.') && String(this.state.form.items[index][event.target.name]).includes('.')) || (Number.isNaN(value) || (value < 0))) {
            return;
        }
        if (decimalType.includes(event.target.name)) {
            let threeDecimal = ['amount'];
            if (threeDecimal.includes(event.target.name)) {
                if (event.target.value) {
                    if (event.target.value) {
                        event.target.value = event.target.value
                            .replace(/[^\d.]/g, '')
                            .replace(new RegExp("(^[\\d]{" + 10 + "})[\\d]", "g"), '$1')
                            .replace(/(\..*)\./g, '$1')
                            .replace(new RegExp("(\\.[\\d]{" + 2 + "}).", "g"), '$1');
                    }
                    if (!event.target.value.match(/^\d{0,5}(\.$|\.\d{0,2}$|$)/)) {
                        if (isNaN(event.target.value))
                            event.target.value = '';
                    }
                }
            }
        }
        if (twodecimal.includes(event.target.name)) {
            let threeDecimal = ['buyerspremium', 'tax'];
            if (threeDecimal.includes(event.target.name)) {
                if (event.target.value) {
                    if (event.target.value) {
                        event.target.value = event.target.value
                            .replace(/[^\d.]/g, '')
                            .replace(new RegExp("(^[\\d]{" + 3 + "})[\\d]", "g"), '$1')
                            .replace(/(\..*)\./g, '$1')
                            .replace(new RegExp("(\\.[\\d]{" + 3 + "}).", "g"), '$1');
                    }
                    if (!event.target.value.match(/^\d{0,3}(\.$|\.\d{0,3}$|$)/)) {
                        if (isNaN(event.target.value))
                            event.target.value = '';
                    }
                }
            }
        }
        this.invoiceData['items'][index][event.target.name] = parseFloat(value);

        const items = [...this.state.form.items];
        if (['amount', 'buyerspremium', 'tax'].includes(event.target.name)) {

            if (event.target.name !== 'tax') {
                const buyerspremiumamount = parseFloat(this.invoiceData.items[index]['amount'] * this.invoiceData['items'][index]['buyerspremium']) / 100;
                this.invoiceData['items'][index]['buyerspremiumamount'] = buyerspremiumamount;
                items[index]['buyerspremiumamount'] = buyerspremiumamount;
            }

            if (this.state.form.taxExemptFlag) {
                if (event.target.name !== 'buyerspremium') {
                    const taxamount = parseFloat(this.invoiceData.items[index]['amount'] * this.invoiceData['items'][index]['tax']) / 100;
                    this.invoiceData['items'][index]['taxamount'] = taxamount;
                    items[index]['taxamount'] = taxamount;
                }

                if (this.invoiceData.applytaxonbp) {
                    const taxonBPamount = parseFloat(this.invoiceData.items[index]['buyerspremiumamount'] * this.invoiceData['items'][index]['tax']) / 100;
                    this.invoiceData['items'][index]['taxonBPamount'] = taxonBPamount;
                    items[index]['taxonBPamount'] = taxonBPamount;
                }
            }          

            const grossamount = this.invoiceData.items[index]['amount'] +
                this.invoiceData['items'][index]['buyerspremiumamount'] + this.invoiceData.items[index]['taxamount'] + (this.invoiceData.applytaxonbp ? this.invoiceData['items'][index]['taxonBPamount'] : 0);
            
            this.invoiceData['items'][index]['grossamount'] = grossamount;
            items[index]['grossamount'] = grossamount;
            
        }

        items[index][event.target.name] = event.target.value;
        this.setState({
            form: {
                ...this.state.form,
                items: [...items]
            },
            noUpdate: false
        }, () => this.calculateTotal());
    };

    // update shipping and additional amount
    onExtraChargeInputChange = (event) => {
        let value = event.target.value !== '' ? parseFloat(event.target.value) : 0;
        if (((event.nativeEvent.data === '.') && String(this.state.form[event.target.name]).includes('.'))
            || (Number.isNaN(value) || value < 0)) {
            return;
        }
        if (decimalTypes.includes(event.target.name)) {
            let threeDecimal = ['shippinghandling', 'additionalamount'];
            if (threeDecimal.includes(event.target.name)) {
                if (event.target.value) {
                    if (event.target.value) {
                        event.target.value = event.target.value
                            .replace(/[^\d.]/g, '')
                            .replace(new RegExp("(^[\\d]{" + 10 + "})[\\d]", "g"), '$1')
                            .replace(/(\..*)\./g, '$1')
                            .replace(new RegExp("(\\.[\\d]{" + 2 + "}).", "g"), '$1');
                    }
                    if (!event.target.value.match(/^\d{0,10}(\.$|\.\d{0,2}$|$)/)) {
                        if (isNaN(event.target.value))
                            event.target.value = '';
                    }
                }
            }
        }
        this.invoiceData[event.target.name] = value;

        this.setState({
            form: {
                ...this.state.form,
                [event.target.name]: event.target.value
            },
            noUpdate: false
        }, () => this.calculateTotal());
    };

    // removes items from list
    removeItem = (index) => {
        const invoiceDataItems = [...this.invoiceData.items];
        invoiceDataItems.splice(index, 1);
        this.invoiceData['items'] = invoiceDataItems;

        const stateItems = [...this.state.form.items];
        stateItems.splice(index, 1);
        this.setState({
            form: {
                ...this.state.form,
                items: stateItems
            },
            noUpdate: false
        }, () => this.calculateTotal());
    };

    updateInvoice = async () => {
        this.setState({ updateLoading: true });
        this.invoiceData['totalamount'] = this.invoiceData.invoiceamount;
        const data = {
            parentinvoiceid: this.state.form.id,
            invoiceamount: this.invoiceData.invoiceamount,
            details: JSON.stringify(this.invoiceData),
            buyerid: this.state.form.buyerid,
            type: this.state.form.type,
            saleid: this.state.form.saleid,
            additionalnotes: this.state.additionalnotes,
        };

        await axios.post(getSellerUrl(updateInvoice), { data: data }, getSellerHeaders())
            .then(response => {
                // toast.success('Updated successfully');
                this.setState({
                    updateLoading: false,
                    invoiceStatus: { show: true, type: 'success', message: 'Saved' },
                    noUpdate: true
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            invoiceStatus: { show: false, type: 'success', message: '' }
                        },
                        //  () => {
                        //     // if(this.props.location.state !== undefined && "from" in this.props.location.state && this.props.location.state.from === "dashboard" ){
                        //     //     this.props.history.goBack()
                        //     // }
                        //     // else{
                        //     this.navigateToBack()
                        //     //this.props.history.push('/invoice')
                        //     // }
                        // }
                        );
                    }, 3000);
                });
            })
            .catch(error => {
                // toast.error(error.response.data.message);
                this.setState({
                    updateLoading: false,
                    voidStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                });
            });
    };

    voidUpdate = () => {
        this.setState({voidModal: true})
    }
    setUpdate = () => {
        this.setState({updateLoading: true})
    }

    setModal = () => {
        this.setState({voidModal: false})
    }
    discardInvoice = async () => {
        this.setState({
            updateDiscardModal: false,
            noUpdate: true
        }, () => {
            this.navigateToBack()
        })
    }
    updateVoid = async () => {
        this.setState({ updateVoid: true });
        let data = [
                {
                    "id": this.state.form.id
                }
            ]

        await axios.put(getSellerUrl(voidInvoice), { data }, getSellerHeaders(this.state.buyerToken))
            .then(response => {
                this.setState({
                    updateVoid: false,
                    voidStatus: { show: true, type: 'success', message: 'Saved' },
                    voidModal: false
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            voidStatus: { show: false, type: 'success', message: '' }
                        },
                        );
                    }, 3000);
                });
            })
            .catch(error => {
                this.setState({
                    updateVoid: false,
                    voidStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                });
            });
    };

    handleChange(event) {
        var input = event.target.value;
        this.setState({
            chars_left: 500 - input.length,
            [event.target.name]: event.target.value,
            noUpdate: false

        });
    };
    navigateToBack = () => {
        if (!this.state.noUpdate) {
            this.setState({
                updateDiscardModal: true
            })
        } else {
            const state = this.props.location.state;

            if (this.props.location.state !== undefined && this.props.location.state.name === "Saledashboard") {
                this.props.history.push({ pathname: this.props.location.state.prevPath, state: state })
            }
            else {
                this.props.history.push({ pathname: '/invoice', state: this.props.location.state });
            }
        }
    };

    getSecretKey() {
        axios.get(getSellerUrl(`${secret_key}`), getSellerHeaders()).then(
            response => {
                if (response.data.status.toLowerCase() === 'success') {
                    this.setState({
                        buyerToken: response.data.accessToken
                    }, () => {
                    })
                }
            }).catch(
                error => {
                    this.setState({
                        secretKey:""  
                    })
                }
            );
    }


    render() {
        if (this.state.errorpageredirect) {
            // redirect to Not-Found if wrong Invoiceid
            return <NoData {...this.props} type="apiError" />
        }
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                {
                    this.state.loading ?
                        <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100" style={{ padding: "30%" }}>
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                        </div> :
                        <div className="invoiceEdit container h-90" style={{ width: this.state.windowWidth > 425 ? '75%' : '100%' }}>

                            {/* action button */}
                            <div className="d-flex no-print">

                                <Button className="btn-secondary m-1 ml-2" style={{ width: "86px", height: "40px", backgroundColor: "#6a5a5d", borderColor: "#6a5a5d" }} onClick={() => { this.navigateToBack() }}><i className="fa fa-chevron-left"></i> Back</Button>
                                <div className="w-100 d-flex justify-content-end">
                                    {
                                        this.state.invoiceStatus.show ?
                                            <ToasterMessage type={this.state.invoiceStatus.type} message={this.state.invoiceStatus.message} className="alert-handle mt-2"></ToasterMessage>
                                            : null
                                    }

                                    <Button className="btn-secondary m-1 ml-2" disabled={this.state.invoiceStatus.type === 'success' || this.state.disableUpdate || this.state.updateLoading || this.state.noUpdate} onClick={() => { 
                                        if(this.state.initalInvoice != this.state.form){
                                            this.setState({
                                                cancelInvoice:true
                                            })
                                        } else {
                                           this.navigateToBack()
                                        }
                                         }}>Cancel</Button>
                                    <Button className="btn-secondary m-1 ml-2" onClick={this.voidUpdate} disabled={this.state.voidStatus.type === 'success' || this.state.updateVoid}>Void {' '} {this.state.updateVoid ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                    <Button className="btn-secondary m-1 ml-2" disabled={this.state.invoiceStatus.type === 'success' || this.state.disableUpdate || this.state.updateLoading || this.state.noUpdate} onClick={this.setUpdate}>Update Invoice {' '} {this.state.updateLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                </div>
                            </div>

                            <Modal style={{ padding: "10px" }} centered animation={false} backdrop="static" show={this.state.updateLoading} id="invoiceVoidModal" className="suspendModal" >
                                <Modal.Body className="d-flex justify-content-end align-items-end">
                                    <div className="d-flex flex-column justify-content-center align-items-center">
                                        Invoice will be voided and a new one created proceed?
                                        <div className="d-flex flex-row mt-4">
                                            <Button onClick={this.updateInvoice} className="btn-white"> Yes </Button>
                                            <Button onClick={() => this.setState({ updateLoading: false })} className="btn-secondary ml-2">No</Button>
                                        </div>
                                    </div>
                                </Modal.Body>
                            </Modal>
                            <Modal style={{ padding: "10px" }} centered animation={false} backdrop="static" show={this.state.cancelInvoice} id="invoiceVoidModal" className="suspendModal" >
                                <Modal.Body className="d-flex justify-content-end align-items-end">
                                    <div className="d-flex flex-column justify-content-center align-items-center">
                                    Are you sure you want to discard this invoice?
                                        <div className="d-flex flex-row mt-4">
                                            <Button onClick={this.navigateToBack} className="btn-white"> Yes </Button>
                                            <Button onClick={() => {}} className="btn-secondary ml-2">No</Button>
                                        </div>
                                    </div>
                                </Modal.Body>
                            </Modal>

                            <Modal style={{ padding: "10px" }} centered animation={false} backdrop="static" show={this.state.voidModal} id="invoiceVoidModal" className="suspendModal" >
                                <Modal.Body className="d-flex justify-content-end align-items-end">
                                    <div className="d-flex flex-column justify-content-center align-items-center">
                                        Are you sure you want to void this invoice?
                                        <div className="d-flex flex-row mt-4">
                                            <Button onClick={this.updateVoid} disabled={this.state.voidStatus.type === 'success' || this.state.updateVoid} className="btn-white"> Yes </Button>
                                            <Button onClick={this.setModal} className="btn-secondary ml-2">No</Button>
                                        </div>
                                    </div>
                                </Modal.Body>
                            </Modal>


                            <Modal style={{ padding: "10px" }} centered animation={false} backdrop="static" show={this.state.updateDiscardModal} id="invoiceVoidModal" className="suspendModal" >
                                <Modal.Body className="d-flex justify-content-end align-items-end">
                                    <div className="d-flex flex-column justify-content-center align-items-center">
                                        Are you sure you want to discard this invoice?
                                        <div className="d-flex flex-row mt-4">
                                            <Button onClick={this.discardInvoice} className="btn-white"> Yes </Button>
                                            <Button onClick={() => this.setState({ updateDiscardModal: false })} className="btn-secondary ml-2">No</Button>
                                        </div>
                                    </div>
                                </Modal.Body>
                            </Modal>
                            <div className="invoiceBorder print" id="invoiceGenration">

                                {/* logo and invoice number */}
                                <div className={`${this.state.windowWidth > 800 ? "d-flex flex-row" : ""} p-4 border-bottom ${this.state.windowWidth > 800 ? '' : 'row'}`}>
                                    <div className={` ${this.state.windowWidth > 800 ? 'justify-content-left text-left w-50' : 'justify-content-center text-center'} col-md-6 col-xs-12`}><img src={`${process.env.PUBLIC_URL}/static/logo/CTBids_logo.png`} alt="logo" height="60px" width="170px" /></div>
                                    <div className={` ${this.state.windowWidth > 800 ? 'justify-content-end text-right w-50 mt-3' : 'justify-content-center text-center mt-1'} text-secondary col-xs-12 col-md-6`}><h2>Invoice:{this.state.form.invoicenumber}</h2></div>
                                </div>

                                {/* address details */}
                                <div className={`${this.state.windowWidth > 800 ? "d-flex row" : ""} p-4 border-bottom mx-0`}>

                                    {/* to address */}
                                    <div className="col col-md-4 col-xs-12 padding">
                                        <p><b className="text-secondary"> Billing To </b></p>
                                        {Object.keys(this.state.form.billingto).map((key) =>
                                            key === 'name' ? <p><b>{this.state.form.billingto[key]}</b></p> :
                                                key === 'phonenumber' ? this.state.form.billingto[key] ? <p>Phone No: {this.state.form.billingto[key]}</p> : '' :
                                                    key === 'email' ? <p style={{ color: "#1d9aa5" }}>{this.state.form.billingto[key]}</p> : <p>{this.state.form.billingto[key]}</p>
                                        )}
                                    </div>

                                    {/* from address */}
                                    <div className="col col-md-4 col-xs-12 padding">
                                        <p><b className="text-secondary">Pickup Location </b></p>
                                        {Object.keys(this.state.form.billingfrom).map((key) =>
                                            key === 'contactname' ? <p><b>{this.state.form.billingfrom[key]}</b></p> :
                                                key === 'contactmobile' ? this.state.form.billingfrom[key] ? <p >Phone No: {this.state.form.billingfrom[key]}</p> : '' :
                                                    key === 'contactemail' ? <p style={{ color: "#1d9aa5" }}>{this.state.form.billingfrom.contactemail} </p> : <p>{this.state.form.billingfrom[key]}</p>
                                        )}
                                    </div>

                                    {/* invoice generated date */}
                                    <div className="col col-md-4 col-xs-12">
                                        <p><b className="text-secondary">Invoice Date</b></p>
                                        <p><b>{moment.utc(this.state.form.createddate).local().format('MM/DD/YYYY hh:mm A')} {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</b></p>
                                    </div>
                                </div>

                                {/* invoice details */}
                                {this.state.windowWidth > 800 ? <div style={{ overflowX: "auto" }}>

                                    {/* header of invoice item details */}
                                    <div className="d-flex flex-row row pt-4 px-4 pb-2 border-bottom mx-0 " style={{ color: "#9f2241", flexWrap: "nowrap" }}>
                                        <div className="col col-md-2 col-xs-3">Items</div>
                                        <div className="col col-md-2">SKU</div>
                                        <div className="col">Amount</div>
                                        <div className="col">Tax</div>
                                        <div className="col">Tax Amount</div>
                                        <div className="col">BP</div>
                                        <div className="col">BP Amount</div>
                                        { /* Display Tax on BP Amount If applytaxonbp is (1/true)  */
                                        this.state.form.applytaxonbp ?   <div className="col">BP Tax Amount</div> : '' }
                                        <div className="col">Gross Amount</div>
                                    </div>

                                    {/* value of invoice item details */}
                                    <div className="pt-2 pb-2" >
                                        {
                                            this.state.form.items.map((item, index) =>
                                                <Row className="d-flex flex-row row pt-2 px-4 pb-2 mx-0" style={{ flexWrap: "nowrap", position: "relative" }}>
                                                    {
                                                        // should have atleast one item in list
                                                        this.state.form.items.length > 1 ?
                                                            <i className="fa fa-times fa-lg pr-2 pt-1 text-danger clickable" title="Remove Item"
                                                                style={{ position: "absolute", top: "25%", left: "6px" }} aria-hidden="true"
                                                                onClick={() => this.removeItem(index)} /> :
                                                            ''
                                                    }
                                                    <div className="col col-md-2 py-2 border-bottom" >{item.title}</div>
                                                    <div className="col-md-2 py-2 border-bottom" style={{wordBreak: "break-word"}} >{item.SKU ? `${item.SKU}` : '- - -'}</div>
                                                    <div className="col py-2 border-bottom">
                                                        <span style={{ position: "absolute", top: "15px", left: "18px" }}>$</span>
                                                        <FormControl type="text" name="amount" autoFocus={index === 0} className="rowamount" value={item.amount} onChange={(event) => this.onInputChange(event, index)} />
                                                    </div>
                                                    <div className="col py-2 border-bottom" >
                                                        {this.state.excemptedLocation ?
                                                            <input type="text" className="rowfield" value={item.tax ? `$ ${item.tax}` : '- - -'} /> :
                                                            <div>
                                                                <span style={{ position: "absolute", top: "15px", right: "18px" }}>%</span>
                                                                <FormControl type="text" name="tax" value={item.tax} className="rowamount" max="100" onChange={(event) => this.onInputChange(event, index)} />
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="col py-2 border-bottom" >
                                                        <input type="text" className="rowfield" value={item.taxamount ? `$${parseFloat(item.taxamount).toFixed(2)}` : '- - -'} />
                                                    </div>
                                                    <div className="col py-2 border-bottom" style={{ position: "relative" }}>
                                                        <span style={{ position: "absolute", top: "15px", right: "18px" }}>%</span>
                                                        <FormControl style={{ minMidth: "100px" }} type="text" name="buyerspremium" value={item.buyerspremium} max="100" className="rowamount" onChange={(event) => this.onInputChange(event, index)} />
                                                    </div>
                                                    <div className="col py-2 border-bottom" >
                                                        <input type="text" className="rowfield" value={item.buyerspremiumamount ? `$${parseFloat(item.buyerspremiumamount).toFixed(2)}` : '- - -'} /></div>
                                                        {this.state.form.applytaxonbp ?     <div className="col py-2 border-bottom" >
                                                        <input type="text" className="rowfield" value={item.taxonBPamount ? `$${parseFloat(item.taxonBPamount).toFixed(2)}` : '- - -'} /></div> : '' }
                                                    <div className="col py-2 border-bottom" >
                                                        <input type="text" className="rowfield" value={item.grossamount ? `$${parseFloat(item.grossamount).toFixed(2)}` : '- - -'} />
                                                    </div>
                                                </Row>
                                            )
                                        }
                                    </div>

                                    {/* total of each parameter */}
                                    <div className="d-flex flex-row row pt-2 px-4 pb-1 mx-0" style={{ fontWeight: "bold", flexWrap: "nowrap" }}>
                                    <div className="col col-md-2 py-2 border-bottom" ></div>
                                    <div className="col-md-2 py-2"></div>
                                        <div className="col py-2">
                                            ${parseFloat(this.state.form.totalamount).toFixed(2)}
                                        </div>
                                        <div className="col py-2">
                                            {/* {this.state.form.totaltax}% */}
                                        </div>
                                        <div className="col py-2">
                                            ${parseFloat(this.state.form.totaltaxamount).toFixed(2)}
                                        </div>
                                        <div className="col py-2">
                                            {/* {this.state.form.totalbp}% */}
                                        </div>
                                        <div className="col py-2">
                                            ${parseFloat(this.state.form.totalbpamount).toFixed(2)}
                                        </div>
                                        {/* Display Tax on BP Amount If applytaxonbp is (1/true)  */
                                        this.state.form.applytaxonbp ?      
                                        <div className="col py-2">
                                             ${parseFloat(this.state.form.totaltaxonbpamount).toFixed(2)}
                                        </div> :''}
                                        <div className="col py-2">
                                            ${parseFloat(this.state.form.totalgrossamount).toFixed(2)}
                                        </div>
                                    </div>
                                </div> :
                                    <div>
                                        <div>
                                            <div className="" style={{ margin: "2%" }}>
                                                <div style={{ flexDirection: "row", display: "flex" }}>
                                                    <div className="col" style={{ marginTop: "1.5%", color: "#9f2241" }}>Total Amount</div>
                                                    <div className="col"> ${parseFloat(this.state.form.totalamount).toFixed(2)}</div>
                                                </div>

                                                <div style={{ flexDirection: "row", display: "flex" }}>
                                                    <div className="col" style={{ marginTop: "1.5%", color: "#9f2241" }}>Total Tax Amount</div>
                                                    <div className="col"> ${parseFloat(this.state.form.totaltaxamount).toFixed(2)}</div>
                                                </div>

                                                <div style={{ flexDirection: "row", display: "flex" }}>
                                                    <div className="col" style={{ marginTop: "1.5%", color: "#9f2241" }}>Total BP Amount</div>
                                                    <div className="col"> ${parseFloat(this.state.form.totalbpamount).toFixed(2)}</div>
                                                </div>
                                                <div style={{ flexDirection: "row", display: "flex" }}>
                                                    <div className="col" style={{ marginTop: "1.5%", color: "#9f2241" }}>Total Gross</div>
                                                    <div className="col"> ${parseFloat(this.state.form.totalgrossamount).toFixed(2)}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <Carousel
                                            nextIcon={<span style={{ backgroundColor: "#9f2241", padding: "0% 1%", borderRadius: 20, marginLeft: "15px" }} aria-hidden="true" className="carousel-control-next-icon" />}
                                            prevIcon={<span style={{ backgroundColor: "#9f2241", padding: "0% 1%", borderRadius: 20, marginRight: "15px" }} className="carousel-control-prev-icon" />}
                                            indicators={true} slide={false}>
                                            {/* <span  style={{backgroundColor:"red"}} aria-hidden="true" className="carousel-control-prev-icon" /> */}
                                            {
                                                this.state.form.items.map((item, index) =>
                                                    <Carousel.Item style={{}}>
                                                        <div className="border" style={{ padding: "5%", borderWidth: 1, margin: "1%", borderColor: "#ececec8c" }}>
                                                            {
                                                                // should have atleast one item in list
                                                                this.state.form.items.length > 1 ?
                                                                    <i className="fa fa-times fa-lg pr-2 pt-1 text-danger clickable" title="Remove Item"
                                                                        style={{}} aria-hidden="true"
                                                                        onClick={() => this.removeItem(index)} /> :
                                                                    ''
                                                            }
                                                            <div style={{ flexDirection: "row", display: "flex" }}>
                                                                <div className="col" style={{ marginTop: "1.5%" }}>Items</div>
                                                                <div className="col" style={{ marginTop: "1.5%" }}>{item.title}</div>
                                                            </div>
                                                            <div style={{ flexDirection: "row", display: "flex" }}>
                                                                <div className="col" style={{ marginTop: "3%" }}>Amount</div>
                                                                <div className="col py-2">
                                                                    <span style={{ position: "absolute", top: "15px", left: "18px" }}></span>
                                                                    <FormControl type="text" name="amount" autoFocus={index === 0} className="rowamount" value={item.amount} onChange={(event) => this.onInputChange(event, index)} />
                                                                </div>
                                                            </div>
                                                            <div style={{ flexDirection: "row", display: "flex" }}>
                                                                <div className="col" style={{ marginTop: "1.5%" }}>Tax</div>
                                                                <div className="col py-2" >
                                                                    <span style={{ position: "absolute", top: "15px", right: "18px" }}>%</span>
                                                                    <FormControl type="text" name="tax" value={item.tax} className="rowamount" max="100" onChange={(event) => this.onInputChange(event, index)} />
                                                                </div>
                                                            </div>
                                                            <div style={{ flexDirection: "row", display: "flex" }}>
                                                                <div className="col" style={{ marginTop: "1.5%" }}>Tax Amount</div>
                                                                <div className="col py-2" >{item.taxamount ? `$${parseFloat(item.taxamount).toFixed(2)}` : '- - -'}</div>
                                                            </div>
                                                            <div style={{ flexDirection: "row", display: "flex" }}>
                                                                <div className="col" style={{ marginTop: "1.5%" }}>BP</div>
                                                                <div className="col py-2" style={{ position: "relative" }}>
                                                                    <span style={{ position: "absolute", top: "15px", right: "18px" }}>%</span>
                                                                    <FormControl style={{ minMidth: "100px" }} type="text" name="buyerspremium" value={item.buyerspremium} max="100" className="rowamount" onChange={(event) => this.onInputChange(event, index)} />
                                                                </div>
                                                            </div>
                                                            <div style={{ flexDirection: "row", display: "flex" }}>
                                                                <div className="col" style={{ marginTop: "1.5%" }}>BP Amount</div>
                                                                <div className="col py-2" >{item.buyerspremiumamount ? `$${parseFloat(item.buyerspremiumamount).toFixed(2)}` : '- - -'}</div>
                                                            </div>
                                                            <div style={{ flexDirection: "row", display: "flex" }}>
                                                                <div className="col" style={{ marginTop: "1.5%" }}>Amount</div>
                                                                <div className="col py-2" >{item.grossamount ? `$${parseFloat(item.grossamount).toFixed(2)}` : '- - -'}</div>
                                                            </div>
                                                        </div>
                                                    </Carousel.Item>
                                                )
                                            }
                                            {/* <span style={{backgroundColor:"red"}} aria-hidden="true" className="carousel-control-next-icon" /> */}
                                        </Carousel>
                                    </div>}
                                <div className={`${this.state.windowWidth > 800 ? "d-flex flex-row" : ""}`} style={{ margin: "2% 5%" }}>
                                    <div className="" style={{ width: "100%" }}>
                                        <div style={{ display: "flex", justifyContent: "space-between", width: '75%' }}>
                                            <Form.Label htmlFor="additionalnotes" className="required">Additional Notes</Form.Label>
                                            <span style={{ color: '#878787' }}>{this.state.chars_left}/500</span>
                                        </div>
                                        <Form.Control as="textarea" value={this.state.additionalnotes} name="additionalnotes" style={{ display: "flex", height: '100px', width: '75%' }} maxLength='500' placeholder=" " className="rowamount" onChange={this.handleChange.bind(this)} />
                                    </div>
                                    {/* total amount */}
                                    <div className="" style={{ width: this.state.windowWidth > 800 ? "50%" : "100%", marginTop: 20 }}>
                                        {/* shipping amount */}
                                        <Row className="my-2">
                                            <Col className="text-left text-secondary"><b>Handling Fee</b></Col>
                                            <Col style={{ padding: 0, position: "relative" }} className="text-left text-secondary">
                                                <span style={{ position: "absolute", top: "8px", left: "4px", color: "black" }}>$</span>
                                                <FormControl type="text" name="shippinghandling" id="shippinghandling" value={this.state.form.shippinghandling} className="rowamount" onChange={(event) => this.onExtraChargeInputChange(event)} />
                                                {/* <b>{this.state.form.shippinghandling ? `$${parseFloat(this.state.form.shippinghandling).toFixed(2)}` : '- - -'}</b> */}
                                            </Col>
                                        </Row>

                                        {/* additional amount */}
                                        <Row className="my-2">
                                            <Col className="text-left text-secondary"><b>Additional Amount</b></Col>
                                            <Col style={{ padding: 0, position: "relative" }} className="text-left text-secondary">
                                                <span style={{ position: "absolute", top: "8px", left: "4px", color: "black" }}>$</span>
                                                <FormControl type="text" name="additionalamount" id="additionalamount" value={this.state.form.additionalamount} className="rowamount" onChange={(event) => this.onExtraChargeInputChange(event)} />
                                                {/* <b>{this.state.form.shippinghandling ? `$${parseFloat(this.state.form.shippinghandling).toFixed(2)}` : '- - -'}</b> */}
                                            </Col>
                                        </Row>

                                        {/* total amount */}
                                        <Row className="my-2" >
                                            <Col className="text-left text-secondary"><b>Total Amount</b></Col>
                                            <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "15px" : "20px" }} className="text-left text-secondary"><b>{this.state.form.invoiceamount ? `$ ${parseFloat(this.state.form.invoiceamount).toFixed(2)}` : '- - -'}</b></Col>
                                        </Row>
                                    </div>
                                </div>
                                {/* invoice message */}
                                {/* <div className="px-5 py-2 border-bottom" dangerouslySetInnerHTML={{ __html: this.state.form.invoicemessage }}>
                                </div> */}
                                <div className="px-5 py-4 border-bottom" dangerouslySetInnerHTML={{ __html: this.state.form.invoicemessage }}>

                                </div>
                            </div>
                        </div>
                }
            </div>
        );
    }
}